import { render, staticRenderFns } from "./DatasourceForm.vue?vue&type=template&id=576aaf56&"
import script from "./DatasourceForm.vue?vue&type=script&lang=js&"
export * from "./DatasourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports